enum ModelType {
  CHALLENGE = 'CHALLENGE',
  TASK = 'TASK',
}

export default ModelType;
